import type { IntlShape } from "react-intl";
import type { IValuationIndicatorCategory } from "types/graphqlTypes";

type TValuationTab = `${IValuationIndicatorCategory}` | "MY_INDICATORS";

export default function getTabName(intl: IntlShape, tab: TValuationTab) {
  if (tab === "VALUATION") {
    return intl.formatMessage({
      description: "Aba do valuation",
      defaultMessage: "Valuation",
      id: "AnXa6O",
    });
  }
  if (tab === "MARKET_CAPITALIZATION") {
    return intl.formatMessage({
      description: "Aba do valuation",
      defaultMessage: "Market Cap",
      id: "zxW5JU",
    });
  }
  if (tab === "EARNINGS") {
    return intl.formatMessage({
      description: "Aba do valuation",
      defaultMessage: "Proventos",
      id: "Wjy9lN",
    });
  }
  if (tab === "PROFITABILITY") {
    return intl.formatMessage({
      description: "Aba do valuation",
      defaultMessage: "Lucratividade",
      id: "U7FcZ5",
    });
  }
  if (tab === "GROWTH") {
    return intl.formatMessage({
      description: "Aba do valuation",
      defaultMessage: "Crescimento",
      id: "LY3lGZ",
    });
  }
  if (tab === "LEVERAGE") {
    return intl.formatMessage({
      description: "Aba do valuation",
      defaultMessage: "Alavancagem",
      id: "J8XXeG",
    });
  }
  if (tab === "MY_INDICATORS") {
    return intl.formatMessage({
      description: "Aba do valuation",
      defaultMessage: "Favoritos",
      id: "G2fisX",
    });
  }
  throw new Error(`Unknown tab: ${tab}`);
}
